import React, { useCallback } from 'react';

import BasePill from '../BasePill';
import DismissPill from './DismissPill';
import { renderInfoPillIcon, renderInfoPillLabel } from './renderers';
import { InfoPillProps } from './types';
import { DEFAULT_INFO_PILL_APPEARANCE, getInfoPillClasses } from './utils';
import { getDomAttributes } from '../../utils';

const InfoPill = React.forwardRef<HTMLDivElement, InfoPillProps>((props, ref) => {
  const {
    appearance = DEFAULT_INFO_PILL_APPEARANCE,
    className,
    onDelete,
    shape = 'round',
    size = 'large',
    type = 'text',
    variant = 'filled',
    onClick,
  } = props;

  const actionable = !!onDelete;

  const classes = getInfoPillClasses({
    actionable,
    appearance,
    shape,
    size,
    type,
    variant,
  });

  const handleDelete = useCallback(
    (event: React.MouseEvent<HTMLDivElement>) => {
      event.stopPropagation();
      onDelete?.(event);
    },
    [onDelete],
  );

  return (
    <BasePill
      ref={ref}
      className={className}
      classes={classes}
      deleteIcon={actionable ? <DismissPill appearance={appearance} size={size} /> : undefined}
      icon={renderInfoPillIcon(props)}
      label={renderInfoPillLabel(props)}
      onDelete={actionable ? handleDelete : undefined}
      onClick={onClick}
      {...getDomAttributes(props)}
    />
  );
});

export default InfoPill;
